export default {
  path: '/ratio-order-detail',
  meta: {
    title: '订单详情',

  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/ratio-order-detail`),
}



// WEBPACK FOOTER //
// ./src/views/RatioOrderDetail/router.js